import React from "react";
import Button from "../Buttons/Button";

export interface BtnProps {
    text?: string
    pageNumber: number
    isCurrentPage?: boolean
    disabled?: boolean
    changePageNumber: (pageNumber: number) => void
}

const Btn: React.FC<BtnProps> = ({ text, pageNumber, changePageNumber, isCurrentPage, disabled }) => {

    if (!text)
        text = pageNumber.toString()

    let classNames = 'paging-button'
    if (isCurrentPage === true)
        classNames += ' current-page'

    return (
        <Button className={classNames} text={text} type={"button"} onClick={() => changePageNumber(pageNumber)} disabled={disabled} />
    );
}
export default Btn;